import action from 'utils/actionCreators';

export const GET_REPORT_REQUEST = 'REPORT/GET_REPORT_REQUEST';
export const GET_REPORT_SUCCESS = 'REPORT/GET_REPORT_SUCCESS';
export const GET_REPORT_FAILURE = 'REPORT/GET_REPORT_FAILURE';

export const POST_REPORT_REQUEST = 'REPORT/POST_REPORT_REQUEST';
export const POST_REPORT_SUCCESS = 'REPORT/POST_REPORT_SUCCESS';
export const POST_REPORT_FAILURE = 'REPORT/POST_REPORT_FAILURE';

export const UPDATE_REPORT_REQUEST = 'REPORT/UPDATE_REPORT_REQUEST';
export const UPDATE_REPORT_SUCCESS = 'REPORT/UPDATE_REPORT_SUCCESS';
export const UPDATE_REPORT_FAILURE = 'REPORT/UPDATE_REPORT_FAILURE';

export const DELETE_REPORT_REQUEST = 'REPORT/DELETE_REPORT_REQUEST';
export const DELETE_REPORT_SUCCESS = 'REPORT/DELETE_REPORT_SUCCESS';
export const DELETE_REPORT_FAILURE = 'REPORT/DELETE_REPORT_FAILURE';

export const RUN_REPORT_REQUEST = 'REPORT/RUN_REPORT_REQUEST';
export const RUN_REPORT_SUCCESS = 'REPORT/RUN_REPORT_SUCCESS';
export const RUN_REPORT_FILTER_REQUEST = 'REPORT/RUN_REPORT_FILTER_REQUEST';
export const RUN_REPORT_FILTER_SUCCESS = 'REPORT/RUN_REPORT_FILTER_SUCCESS';
export const RUN_REPORT_FAILURE = 'REPORT/RUN_REPORT_FAILURE';
export const SELECT_REPORT = 'REPORT/SELECT_REPORT';
export const OPEN_CONFIRMATION_MODAL = 'REPORT/OPEN_CONFIRMATION_MODAL';
export const CLOSE_CONFIRMATION_MODAL = 'REPORT/CLOSE_CONFIRMATION_MODAL';
export const SELECT_FILTERS = 'REPORT/SELECT_FILTERS';
export const SELECT_FILTERS_WITHOUT_COST_CENTER =
  'REPORT/SELECT_FILTERS_WITHOUT_COST_CENTER';
export const SELECT_FILTER_BY_DATE = 'REPORT/SELECT_FILTER_BY_DATE';
export const REMOVE_SELECTED_FILTER = 'REPORT/REMOVE_SELECTED_FILTER';
export const OPEN_FORM_MODAL = 'REPORT/OPEN_FORM_MODAL';
export const CLOSE_FORM_MODAL = 'REPORT/CLOSE_FORM_MODAL';
export const UPDATE_FORM_FIELD = 'REPORT/UPDATE_FORM_FIELD';
export const RESET_FORM_FIELD = 'REPORT/RESET_FORM_FIELD';
export const RESET_STATE = 'REPORT/RESET_STATE';
export const SORT_SELECTED_OPTIONS =
  'SORT_SELECTED_OPTIONS/SORT_SELECTED_OPTIONS';

export const getReportRequest = action(GET_REPORT_REQUEST, 'payload');
export const postReportRequest = action(POST_REPORT_REQUEST, 'payload');
export const postReportSuccess = action(POST_REPORT_SUCCESS, 'payload');
export const updateReportRequest = action(UPDATE_REPORT_REQUEST, 'payload');
export const deleteReportRequest = action(DELETE_REPORT_REQUEST, 'payload');
export const runReportRequest = action(RUN_REPORT_REQUEST, 'payload');
export const runReportFilterRequest = action(
  RUN_REPORT_FILTER_REQUEST,
  'payload',
);
export const selectReport = action(SELECT_REPORT, 'payload');
export const openConfirmationModal = action(OPEN_CONFIRMATION_MODAL, 'payload');
export const closeConfirmationModal = action(CLOSE_CONFIRMATION_MODAL);
export const sortSelectedOptions = action(SORT_SELECTED_OPTIONS, 'payload');
export const selectFilters = action(SELECT_FILTERS, 'payload');
export const selectFiltersWithoutCostCenter = action(
  SELECT_FILTERS_WITHOUT_COST_CENTER,
  'payload',
);
export const selectFilterByDate = action(SELECT_FILTER_BY_DATE, 'payload');
export const removeSelectedFilter = action(REMOVE_SELECTED_FILTER, 'payload');
export const openFormModal = action(OPEN_FORM_MODAL);
export const closeFormModal = action(CLOSE_FORM_MODAL);
export const updateFormField = action(UPDATE_FORM_FIELD, 'payload');
export const resetFormField = action(RESET_FORM_FIELD);
export const resetState = action(RESET_STATE);
